import React from 'react';
import { Box } from '@mui/material';
import PatientStudentSelector from './PatientStudentSelector';
import ReminderNotes from './ReminderNotes';
import DateTimePickers from './DateTimePickers';
import PrioritySelector from './PrioritySelector';
import ReminderActions from './ReminderActions';

export default function ReminderForm({
  typeOfUser,
  selectedPatient,
  selectedStudent,
  patientData,
  studentsGoalData,
  textReminder,
  selectedDates,
  time,
  priority,
  truncateName,
  setSelectedPatient,
  setSelectedStudent,
  handleTextChangeHandler,
  handleDateChange,
  handleDeleteWithConfirmation,
  updateTime,
  addTimePicker,
  handlePriorityChange,
  handleViewAllReminders,
  setReminderHandler,
  isTeacherContext = false,
  currentEntity = null,
  isEditing = false,
  isLoading = false,
}) {
  return (
    <>
      <Box
        className='fullWidth fullHeight flexBox flexColumn Reminders'
        gap={2}
        sx={{
          backgroundColor: 'var(--clr-mindly-background)',
          // borderRadius: 1,
        }}
      >
        <PatientStudentSelector
          typeOfUser={typeOfUser}
          selectedPatient={selectedPatient}
          selectedStudent={selectedStudent}
          patientData={patientData}
          studentsGoalData={studentsGoalData}
          truncateName={truncateName}
          setSelectedPatient={setSelectedPatient}
          setSelectedStudent={setSelectedStudent}
          isTeacherContext={isTeacherContext}
          currentEntity={currentEntity}
          selectionDisabled={isEditing}
        />

        <ReminderNotes
          textReminder={textReminder}
          handleTextChangeHandler={handleTextChangeHandler}
        />

        <DateTimePickers
          selectedDates={selectedDates}
          time={time}
          handleDateChange={handleDateChange}
          handleDeleteWithConfirmation={handleDeleteWithConfirmation}
          updateTime={updateTime}
          addTimePicker={addTimePicker}
        />
      </Box>

      <PrioritySelector
        priority={priority}
        handlePriorityChange={handlePriorityChange}
      />

      <ReminderActions
        handleViewAllReminders={handleViewAllReminders}
        setReminderHandler={setReminderHandler}
        isEditing={isEditing}
        isLoading={isLoading}
      />
    </>
  );
}
